import { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { PAGE_ROUTE, API_URL } from "../shared/constant";
import { Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import LoaderComponent from "../../admin/shared/loader";
import axios from "axios";
import Crop from "../shared/crop";
import RichTextEditor from "react-rte";

const ProductFormComponent = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [usesPreview, setUsesPreview] = useState("");
  const [imagePreviewOne, setImagePreviewOne] = useState("");
  const [imagePreviewTwo, setImagePreviewTwo] = useState("");
  const [imagePreviewThree, setImagePreviewThree] = useState("");
  const [imagePreviewFour, setImagePreviewFour] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [loginId, setloginId] = useState("");
  const inputRef = useRef(null);
  const [categoryDrp, setCategoryDrpData] = useState([]);
  const [croptype, setCropType] = useState("round");
  const [error, setError] = useState([]);
  const [sizeDrp, setsizeDrpData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    category_id: "",
    description: RichTextEditor.createEmptyValue(),
    preview: "",
    preview_code: "",
    image: "",
    image_two: "",
    image_uses: "",
    image_three: "",
    image_four: "",
    image_code: "",
    image_two_code: "",
    image_three_code: "",
    image_four_code: "",
    size_id: "",
    app_ids: []
  });

  useEffect(() => {
    if (id) {
      onEdit();
    }
  }, [id]);

  const getCategoryDrpData = () => {
    axios.post(API_URL.ADMIN_CATEGORY_LIST, {}).then((res) => {
      setCategoryDrpData(res.data.data);
    });
  };
  const getsizeDrpData = () => {
    axios.post(API_URL.ADMIN_SIZE_LIST, {}).then((res) => {
      setsizeDrpData(res.data.data);
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!id) {
      if (isInvalid(formData.name)) {
        toast.error("Name Is Required");
        return false;
      }
      if (isInvalid(formData.category_id)) {
        toast.error("Category Is Required");
        return false;
      }
      if (isInvalid(formData.size_id)) {
        toast.error("Size Is Required");
        return false;
      }
      if (isInvalid(formData.preview)) {
        toast.error("Preview Is Required");
        return false;
      }

      if (isInvalid(formData.description)) {
        toast.error("Description Is Required");
        return false;
      }
    }

    setError([]);
    setLoading(true);
    let url = API_URL.ADMIN_PRODUCT_SAVE;
    let body = JSON.parse(JSON.stringify(formData));
    body.description = formData.description
      ? formData.description.toString("html")
      : "";

    if (body.app_ids && body.app_ids.length > 0) {
      let app_ids = [];
      body.app_ids.map((res) => {
        app_ids.push(res.value);
      });
      body.app_ids = app_ids.toString();
    }
    if (id) {
      body["id"] = id;
      url = API_URL.ADMIN_PRODUCT_UPDATE;
    }
    axios.post(url, body).then(
      (response) => {
        setLoading(false);
        if (response.data.status === 1) {
          if (id) {
            toast.success("Product Updated Successfully", { autoClose: 3000 });
          } else {
            toast.success("Product Created Successfully", { autoClose: 3000 });
          }
          setTimeout(() => {
            navigate(PAGE_ROUTE.ADMIN_PRODUCT_LIST, { replace: true });
          }, 100);
        } else {
          if (response.data && response.data.data) {
            let errors = [];
            Object.keys(response.data.data).forEach((key) => {
              errors.push(response.data.data[key][0]);
            });
            setError(errors);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        }
      },
      (error) => {
        toast.error("Something went wrong..", { autoClose: 3000 });
        setLoading(false);
      }
    );
  };

  const isInvalid = (value) => {
    return !value || value === "" || value === null;
  };

  const onEdit = () => {
    axios.post(API_URL.ADMIN_PRODUCT_GET + id).then((response) => {
      if (response.data.status === 1) {
        let app_ids = [];
        if (response.data.data.app_ids) {
          let array = response.data.data.app_ids.split(",");
          if (array && array.length > 0) {
            array.map((res) => {
              app_ids.push({ label: res, value: res });
            });
          }
        }
        setFormData({
          name: response.data.data.name,
          category_id: response.data.data.category_id,
          description: response.data.data.description
            ? RichTextEditor.createValueFromString(
              response.data.data.description,
              "html"
            )
            : "",
          size_id: response.data.data.size_id,
          preview_code: response.data.data.preview_code,
          image_code: response.data.data.image_code,
          image_two_code: response.data.data.image_two_code,
          image_three_code: response.data.data.image_three_code,
          image_four_code: response.data.data.image_four_code,
          app_ids: app_ids,
        });

        if (response.data.data.preview) {
          setImagePreview(response.data.data.preview)
        }
        if (response.data.data.image) {
          setImagePreviewOne(response.data.data.image)
        }
        if (response.data.data.image_uses) {
          setUsesPreview(response.data.data.image_uses)
        }
        if (response.data.data.image_two) {
          setImagePreviewTwo(response.data.data.image_two)
        }
        if (response.data.data.image_three) {
          setImagePreviewThree(response.data.data.image_three)
        }
        if (response.data.data.image_four) {
          setImagePreviewFour(response.data.data.image_four)
        }
      }
    });
  };

  const getLoginId = () => {
    let lid = sessionStorage.getItem("login_id");
    setloginId(lid);
  };

  useEffect(() => {
    getLoginId();
    getCategoryDrpData();
    getsizeDrpData();
  }, []);

  const onChangeDesc = (v) => {
    setFormData({ ...formData, description: v });
  };

  const updateSizeValue = (size_id) => {
    if (loginId == 6) {
      let sid = sizeDrp.find((row) => (row.id = size_id));
      let name = sid.name.toLowerCase();
      name = sid.name.split(" ");
      name = name[0].split("x");
      if (name[0] == name[1]) {
        setCropType("round");
      } else setCropType("rect");
    }
  };

  return (
    <div>
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">{id ? "Edit" : "Add"} Product</h4>
          {error.length > 0 && (
            <>
              {["danger"].map((variant) => (
                <Alert key={variant} variant={variant}>
                  {error.map((element, key) => {
                    return <div key={key}>{element}</div>;
                  })}
                </Alert>
              ))}
            </>
          )}
          <form className="forms-sample" onSubmit={onSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        className="form-control"
                        id="name"
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Design Series</label>
                      <Form.Select
                        aria-label="Category"
                        value={formData.category_id}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            category_id: event.target.value,
                          });
                        }}
                      >
                        value={formData.category_id}
                        <option value="">Select</option>
                        {categoryDrp.map((res, key) => {
                          return (
                            <option key={key} value={res.id}>
                              {res.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Design Type</label>
                      <Form.Select
                        aria-label="Series"
                        value={formData.size_id}
                        onChange={(event) => {
                          updateSizeValue(event.target.value);
                          setFormData({
                            ...formData,
                            size_id: event.target.value,
                          });
                        }}
                      >
                        value={formData.size_id}
                        <option value="">Select</option>
                        {sizeDrp.map((res, key) => {
                          return (
                            <option key={key} value={res.id}>
                              {res.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </div>
                  </div>
                  <div className={id ? "col-md-12" : "col-md-12"}>
                    <div className="form-group">
                      <label>Descirption</label>
                      <RichTextEditor
                        className="text-editor"
                        value={formData.description}
                        onChange={onChangeDesc}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Uses</label>
                          <Crop
                            height={100}
                            width={200}
                            imagePreview={usesPreview}
                            cropShape={"RECT"}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                image_uses: fileCroppedBase64,
                              });
                              setUsesPreview(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Color-1</label>
                          <input onChange={(e) => setFormData({ ...formData, preview_code: e.target.value })} value={formData.preview_code} type="text" className="form-control mb-3" placeholder="Enter Code" />
                          <Crop
                            height={270}
                            width={135}
                            cropShape={"rect"}
                            aspectRatio={'2/4'}
                            imagePreview={imagePreview}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                preview: fileCroppedBase64,
                              });
                              setImagePreview(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Color-2</label>
                          <input onChange={(e) => setFormData({ ...formData, image_code: e.target.value })} value={formData.image_code} type="text" className="form-control mb-3" placeholder="Enter Code" />
                          <Crop
                            height={270}
                            width={135}
                            imagePreview={imagePreviewOne}
                            cropShape={"rect"}
                            aspectRatio={'2/4'}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                image: fileCroppedBase64,
                              });
                              setImagePreviewOne(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Color-3</label>
                          <input onChange={(e) => setFormData({ ...formData, image_two_code: e.target.value })} value={formData.image_two_code} type="text" className="form-control mb-3" placeholder="Enter Code" />
                          <Crop
                            height={270}
                            width={135}
                            imagePreview={imagePreviewTwo}
                            aspectRatio={'2/4'}
                            cropShape={"rect"}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                image_two: fileCroppedBase64,
                              });
                              setImagePreviewTwo(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Color-4</label>
                          <input onChange={(e) => setFormData({ ...formData, image_three_code: e.target.value })} value={formData.image_three_code} type="text" className="form-control mb-3" placeholder="Enter Code" />
                          <Crop
                            height={270}
                            width={135}
                            aspectRatio={'2/4'}
                            imagePreview={imagePreviewThree}
                            cropShape={"rect"}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                image_three: fileCroppedBase64,
                              });
                              setImagePreviewThree(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Color-5</label>
                          <input onChange={(e) => setFormData({ ...formData, image_four_code: e.target.value })} value={formData.image_four_code} type="text" className="form-control mb-3" placeholder="Enter Code" />
                          <Crop
                            height={270}
                            width={135}
                            aspectRatio={'2/4'}
                            imagePreview={imagePreviewFour}
                            cropShape={"rect"}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                image_four: fileCroppedBase64,
                              });
                              setImagePreviewFour(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-end">
                {isLoading && (
                  <LoaderComponent
                    type={"watch"}
                    height={35}
                    width={35}
                  ></LoaderComponent>
                )}
                <button type="submit" className="btn btn-primary">
                  {id ? "Update" : "Create"}
                </button>
                <NavLink to="/admin/product" className="btn btn-secondary">
                  Cancel
                </NavLink>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ProductFormComponent;
